// @flow
import ProductConfiguration from '../../../types/product-configuration'
import type { SelectionFilterEntitySet } from '../../../types/selection-filter-entity-set'
import type { FilterSelection } from '../../../types/filter-selection'
import { buildEmptyFilterSelection } from '../../../types/filter-selection'

export type SelectionState = {
  availableFilterEntities: SelectionFilterEntitySet,
  selectedFilterEntities: FilterSelection,
  productConfigurations: ProductConfiguration[],
}

const state: SelectionState = {
  availableFilterEntities: {
    customerGroups: [],
    productCollections: [],
    modalities: [],
    regions: [],
    salesChannels: [],
    products: [],
    terms: []
  },
  selectedFilterEntities: buildEmptyFilterSelection(),
  productConfigurations: []
}

export default state



// WEBPACK FOOTER //
// ./src/store/modules/selection/state.js